import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { useTranslation } from "react-i18next";
import ovni from "../images/clients/ovni.png";
import kws from "../images/clients/kws.png";
import geps from "../images/clients/geps.png";
import protergia from "../images/clients/protergia.png";
import nafo from "../images/clients/nafo.png";
import khuza from "../images/clients/khuza.png";
import utech from "../images/clients/utech.png";
import asie from "../images/clients/asie.png";

const logos = [
  { id: 1, logo: ovni, name: "OVNI" },
  { id: 2, logo: kws, name: "KWS" },
  { id: 3, logo: utech, name: "UTECH" },
  { id: 4, logo: protergia, name: "Protergia" },
  { id: 5, logo: geps, name: "GEPS" },
  { id: 6, logo: nafo, name: "NAFO" },
  { id: 7, logo: khuza, name: "Khuza" },
  { id: 8, logo: asie, name: "Asie" },
];

const containerVariants = {
  hidden: { opacity: 0, y: 18 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
  },
};

const Clients = () => {
  const { t } = useTranslation();
  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="relative bg-white py-28">
      <motion.div
        className="mx-auto max-w-7xl px-6"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-80px" }}
      >
        {/* Heading */}
        <div className="mb-16 text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-blue-900 sm:text-4xl">
            {t("clients.heading")}
          </h2>
          <div className="mx-auto mt-4 h-[2px] w-16 rounded-full bg-blue-900/20" />
        </div>

        {/* Logos band */}
        <div className="relative">
          {/* Edge fades */}
          <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-24 bg-gradient-to-r from-white to-transparent" />
          <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-24 bg-gradient-to-l from-white to-transparent" />

          <div className="overflow-hidden rounded-[32px] border border-slate-200/60">
            <div className="bg-white">
              <div
                className={`flex w-max items-center gap-20 px-20 py-14
                ${prefersReducedMotion ? "" : "animate-logo-float"}
                hover:[animation-play-state:paused]`}
              >
                {[...logos, ...logos].map((item, index) => (
                  <motion.div
                    key={`${item.id}-${index}`}
                    className="flex h-20 w-56 items-center justify-center rounded-2xl bg-white shadow-[0_1px_0_rgba(15,23,42,0.04)] ring-1 ring-slate-200/50"
                    whileHover={{ y: -4 }}
                    transition={{
                      type: "spring",
                      stiffness: 220,
                      damping: 20,
                    }}
                  >
                    <img
                      src={item.logo}
                      alt={`${item.name} logo`}
                      className="max-h-12 w-auto object-contain"
                      draggable={false}
                      loading="lazy"
                    />
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      <style jsx>{`
        @keyframes logo-float {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-logo-float {
          animation: logo-float 36s linear infinite;
        }
        @media (max-width: 640px) {
          .animate-logo-float {
            animation-duration: 24s;
          }
        }
      `}</style>
    </section>
  );
};

export default Clients;
